import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class DicBussinesstypeApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'dicBussinesstype'
    }


    /**
     * 查询字典类型列表
     * @returns 
     */
    public getDicTypeList(){
        return this.send({},"getDicTypeList",Methods.GET)
    }

    /**
     * 保存或更新
     * @param param 
     * @returns 
     */
    public updateDicBussinessType(param){
        return this.send(param,"update",Methods.POST)

    }

    /**
     * 删除
     * @param ids 
     */
    public deleteDicBussinessType(ids){
        return this.send({},"delete?ids="+ids,Methods.POST)
    }


   
}